import { concat, isArray, map } from 'lodash-es'
import bbox from '@turf/bbox'
// [{lng: x, lat: x}]转[lng, lat]
export function boundaryToLngLat(paths) {
  const list = concat(paths)
  return _trf(list)

  function _trf(list) {
    return map(list, item => {
      if (isArray(item)) {
        return _trf(item)
      } else {
        return [item.lng, item.lat]
      }
    })
  }
}

export async function getDirections(points = [], profile = 'driving') {
  const Directions = (await import('@mapbox/mapbox-sdk/services/directions')).default

  const directionsClient = Directions({ accessToken: process.env.NEXT_PUBLIC_MAPBOX_ACCESSTOKEN })
  const waypoints = map(points, item => ({ coordinates: item }))
  const { body } = await directionsClient.getDirections({ waypoints, profile }).send()
  const geojson = await _directionsToGeoJSON(body)
  return {
    geojson,
    body
  }

  async function _directionsToGeoJSON(directions) {
    const Polyline = (await import('@mapbox/polyline')).default
    return {
      type: 'FeatureCollection',
      features: directions.routes.map(function (route) {
        return {
          type: 'Feature',
          properties: {},
          geometry: typeof route.geometry === 'string' ? Polyline.toGeoJSON(route.geometry) : route.geometry
        }
      })
    }
  }
}

/**
 * 计算两点之间的距离
 * @param {Object} coor1 LngLat
 * @param {Object} coor2 LngLat
 * @returns 距离
 */
export function distanceBetwCoor(coor1, coor2) {
  const coor1Lng = isArray(coor1) ? coor1[0] : coor1.lng
  const coor1Lat = isArray(coor1) ? coor1[1] : coor1.lat
  const coor2Lng = isArray(coor2) ? coor2[0] : coor2.lng
  const coor2Lat = isArray(coor2) ? coor2[1] : coor2.lat

  const ang1 = toRad(coor1Lat)
  const ang2 = toRad(coor2Lat)
  const diffAng = toRad(coor2Lat - coor1Lat)
  const diffBng = toRad(coor2Lng - coor1Lng)

  const a = Math.sin(diffAng / 2) * Math.sin(diffAng / 2) +
    Math.cos(ang1) * Math.cos(ang2) *
    Math.sin(diffBng / 2) * Math.sin(diffBng / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return c * 6371

  function toRad(num) {
    return num * Math.PI / 180
  }
}

/**
 * 经纬度转边界
 * @param {array} boundary boundary
 * @returns bounding box
 */
export function boundaryToBounding (boundary) {
  const geojson = {
    'type': 'Feature',
    'properties': {},
    'geometry': {
      'type': 'LineString',
      'coordinates': boundary
    }
  }
  return bbox(geojson)
}